import type { GeneralCache } from './Cache';
import { Cache } from './cache.platform';

export const FastCache: GeneralCache = Cache;

export function getFastCache(): GeneralCache {
  return Cache;
}
